import React, { MouseEventHandler } from 'react'
import { Circle } from 'react-components'

import { DotContainer } from './carousel-dot-styles'

interface CarouselDotProps {
    fillColor: string
    onClick?: MouseEventHandler<HTMLElement>
    label?: string
}

const CarouselDot: React.FC<CarouselDotProps> = ({ fillColor, onClick, label }) => (
    <DotContainer type="button" onClick={onClick} aria-label={label}>
        <Circle radius="0.3125rem" padding="0" fillColor={fillColor} />
    </DotContainer>
)

export default CarouselDot
